import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Plural, Trans } from 'lingui-react';

import { CardElement } from 'elements/Card';
import TextDiv from 'elements/TextDiv';

import BriefcaseIcon from 'components/BriefcaseIcon';

import messages from './messages';

function AssetOpenCases({ assetInfo }) {
  const hasOpenCases = assetInfo.get('hasActiveCases');
  const count = assetInfo.get('countActiveCases');

  if (hasOpenCases) {
    return (
      <CardElement modifiers={['flex']}>
        <BriefcaseIcon name="briefcase" />
        <TextDiv modifiers={['darkGreyText', 'smallText']}>
          <Plural
            value={count}
            one={<Trans># Open Case</Trans>}
            other={<Trans># Open Cases</Trans>}
          />
        </TextDiv>
      </CardElement>
    );
  }
  return (
    <CardElement>
      <TextDiv modifiers={['smallText', 'lightText', 'italic', 'statusDefault']}>
        <Trans id={messages.noOpenCases} />
      </TextDiv>
    </CardElement>
  );
}

AssetOpenCases.propTypes = {
  assetInfo: ImmutablePropTypes.contains({
    countActiveCases: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]).isRequired,
    hasActiveCases: PropTypes.bool.isRequired,
  }).isRequired,
};

export default AssetOpenCases;



// WEBPACK FOOTER //
// ./components/AssetDisplayElement/AssetOpenCases.js